export default "__VITE_ASSET__i2u9tv1a__"